import { lazy } from 'react';

import { GuestApp } from '@/components/base/app/guest-app';
import { useIsLoggedIn } from '@/store/auth.slice';

const AuthenticatedApp = lazy(() => import('./authenticated-app'));

const App = () => {
  const isLoggedIn = useIsLoggedIn();

  return <>{isLoggedIn ? <AuthenticatedApp /> : <GuestApp />}</>;
};

export default App;
